import { gql } from '../__generated__';

gql(/* GraphQL */ `
  fragment GuideMigrationItem on GuideMigrationModel {
    id
    guideId
    docId
    docNumber
    docName
    title
    version
    publishedAt
    publishedAsPdfOnly
    tiptapDocument {
      ...TiptapDocumentItem
    }
  }
`);

export const GET_GUIDE_MIGRATIONS = gql(/* GraphQL */ `
  query GetGuideMigrations {
    guideMigrations(order: { createdAt: DESC }) {
      ...GuideMigrationItem
    }
    guides {
      id
      owner {
        ...UserItem
      }
      mainCategory {
        id
        title
      }
    }
  }
`);

export const GET_GUIDE_MIGRATION = gql(/* GraphQL */ `
  query GetGuideMigration($id: UUID!) {
    guideMigration(id: $id) {
      ...GuideMigrationItem
    }
  }
`);

export const PUBLISH_GUIDE_MIGRATION = gql(/* GraphQL */ `
  mutation PublishGuideMigration($input: PublishGuideMigrationInput!) {
    publishGuideMigration(input: $input) {
      guideMigrationModel {
        ...GuideMigrationItem
      }
    }
  }
`);

export const PUBLISH_GUIDE_MIGRATION_AS_PDF_ONLY = gql(/* GraphQL */ `
  mutation PublishGuideMigrationAsPdfOnly($input: PublishGuideMigrationAsPdfOnlyInput!) {
    publishGuideMigrationAsPdfOnly(input: $input) {
      guideMigrationModel {
        ...GuideMigrationItem
      }
    }
  }
`);
